import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import { createModal } from 'react-modal-promise';

const ConfirmModal = ({ open, close, msg, msgData = {} }: any) => {
    const { t } = useTranslation('dialog');
    return (
        <Modal show={open} onHide={() => close()} backdrop="static" centered>
            <section className="dialogPopup layerSty confirmDlg">
                <h1>{t('confirmation')}</h1>
                <div className="container">
                    <div className="msg">
                        <p>{t(msg, msgData)}</p>
                    </div>
                    <div className="bt">
                        <button type="button" className="button2" onClick={() => close()}>
                            {t('cancel')}
                        </button>
                        <button type="button" className="button1" onClick={() => close(true)}>
                            {t('common:ok')}
                        </button>
                        <button type="button" className="closeBt" onClick={() => close()} />
                    </div>
                </div>
            </section>
        </Modal>
    );
};

export default createModal(ConfirmModal);
